import { createSlice } from '@reduxjs/toolkit';

import { getInvoices, getBoxesForInvoice, createInvoice, downloadInvoice, shipToIndiaSummary, confirmShipToIndia, uploadBoxesForInvoice, uploadInvoice, updateCreateExportOrder } from '../../apis';
import { downloadSTNDetails } from './api';

export const GetInvoice = createSlice({
    name: 'invoiceItems',
    initialState: {
        IsLoading: false,
        data : [],
        error: '',
        invoiceBoxes: [],
        invoiceCreateSuccess: false,
        shipToIndiaModalSuccess: false,
        shipToIndiaSummaryData: {},
        uploadCreateInvoiceSuccess: false,
        uploadInvoiceSuccess: false,
        updateCreateExportOrderSuccess: false,
    },

    reducers: {
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
               ...state,
                [action.payload.key]: action.payload.value
            }
        },
        changeInvoiceCreateSuccessState: (state, action) => {
            return {
                ...state,
                invoiceCreateSuccess: action.payload
            }
        },
        clearShipToIndiaSummaryData: (state, action) => {
            return {
                ...state,
                shipToIndiaSummaryData: action.payload ?? {}
            }
        },
        clearShipToIndiaModalSuccess: (state, action) => {
            return {
                ...state,
                shipToIndiaModalSuccess: action.payload
            }
        },
        clearUploadCreateInvoiceSuccess: (state, action) => {
            return {
                ...state,
                uploadCreateInvoiceSuccess: action.payload
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getInvoices.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getInvoices.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getInvoices.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(getBoxesForInvoice.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getBoxesForInvoice.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.invoiceBoxes = action.payload.data
        })
        builder.addCase(getBoxesForInvoice.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(createInvoice.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(createInvoice.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.invoiceCreateSuccess = true
        })
        builder.addCase(createInvoice.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        
        builder.addCase(downloadInvoice.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(downloadInvoice.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.invoiceCreateSuccess = true
        })
        builder.addCase(downloadInvoice.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(shipToIndiaSummary.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(shipToIndiaSummary.fulfilled, (state, action) => {
            state.IsLoading = false;
            state.error = '';
            state.shipToIndiaSummaryData = action.payload.data;
            // state.shipToIndiaModalSuccess = true;
        })
        builder.addCase(shipToIndiaSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(confirmShipToIndia.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(confirmShipToIndia.fulfilled, (state, action) => {
            state.IsLoading = false;
            state.error = '';
            state.shipToIndiaModalSuccess = true;
        })
        builder.addCase(confirmShipToIndia.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(uploadBoxesForInvoice.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(uploadBoxesForInvoice.fulfilled, (state, action) => {
            state.IsLoading = false;
            state.error = '';
            state.uploadCreateInvoiceSuccess = true;
        })
        builder.addCase(uploadBoxesForInvoice.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(uploadInvoice.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(uploadInvoice.fulfilled, (state, action) => {
            state.IsLoading = false;
            state.error = '';
            state.uploadInvoiceSuccess = true;
        })
        builder.addCase(uploadInvoice.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(updateCreateExportOrder.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(updateCreateExportOrder.fulfilled, (state, action) => {
            state.IsLoading = false;
            state.error = '';
            state.updateCreateExportOrderSuccess = true;
        })
        builder.addCase(updateCreateExportOrder.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(downloadSTNDetails.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        
    }
})
export const { clearErrorState, changeInvoiceCreateSuccessState, clearShipToIndiaSummaryData, clearShipToIndiaModalSuccess, clearUploadCreateInvoiceSuccess, clear } = GetInvoice.actions
export default GetInvoice.reducer